export interface DigitalSignageScreensModel {
  _id: string;
  title: string;
  media?: string;
  appPath: string;
  orgId: number;
  mediaUrl?: string | null;
  sourceType: string;
  mediaType: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export interface ScreensDialogFormProps {
  selectedItem: DigitalSignageScreensModel | null;
  onSave: (data: DigitalSignageScreenReqModel) => void;
}

export interface DigitalSignageScreenReqModel {
  title: string;
  appPath: string;
  media: string;
  mediaType?: string | null;
  mediaUrl?: string | null;
  sourceType: string;
}

export enum SourceType {
  File = 'file',
  Url = 'url',
  AppPath = 'appPath'
}

export enum MediaTypeEnum {
  Html = 'html',
  Image = 'image',
  Video = 'video',
  Audio = 'audio',
  Other = 'other'
}
